import { useEffect, useState } from 'react';
import { Flex, LocalVideo, RemoteVideo, theme } from '../../2022-component-library';
import { useCalibration } from '../../context/calibrationContext';
import { calibrationConstants } from '../../helpers/calibration-constants';
import { useReceiveMessage } from '../../context/messageContext';
import { useDistanceDetector } from '../../helpers/facial-recognition-hooks';
import { usePostMessage } from '../../context/messageContext';

let collections = [];

const BlindspotCameraCalibration = () => {
  const {
    calibrationData: { circleDimensionsPx, pixelDensity },
  } = useCalibration();
  const { updateCalibrationData } = useCalibration();
  const messageFromOptician = useReceiveMessage();
  const [detectDistance, setDetectDistance] = useState(false);
  const [startFaceRecognition, setStartFaceRecognition] = useState(false);
  const { faceApiDetections, calculatedPerceivedFocalLength, getLandmarkData, setReadyToStart } = useDistanceDetector(startFaceRecognition);
  const postMessage = usePostMessage();

  const blindSpotThumbnailWidthPx = 110;
  const blindSpotThumbnailHeightPx = 77;

  const clientYmm = 13.733;
  const clientYpx = clientYmm / pixelDensity;
  const blindSpotVanishingXDistanceMm = 137.33;
  const blindSpotVanishingXDistancePx = blindSpotVanishingXDistanceMm / pixelDensity;

  const blindSpotData = {
    blindSpotVideo: {
      clientX: window.screen.availWidth / 2 - blindSpotThumbnailWidthPx / 2,
      clientY: 100 + blindSpotThumbnailHeightPx / 2,
    },
    blindSpot: {
      clientX:
        window.screen.availWidth / 2 -
        blindSpotThumbnailWidthPx / 2 +
        blindSpotVanishingXDistancePx +
        40 +
        blindSpotThumbnailWidthPx / 2 -
        circleDimensionsPx / 2,
      clientY: 160 + blindSpotThumbnailHeightPx / 2 + clientYpx,
      circleDimensionsPx: circleDimensionsPx,
      show: false,
    },
  };

  useEffect(() => {
    if (faceApiDetections && faceApiDetections?.landmarks && collections.length < 3) {
      const pfc = calculatedPerceivedFocalLength(getLandmarkData(faceApiDetections.landmarks), 513);
      collections.push(pfc);
    } else if (collections.length >= 3) {
      const calculatedPerceivedFocalLength = collections.reduce((acc, val) => acc + val, 0) / collections.length;
      updateCalibrationData({ perceivedFocalLength: calculatedPerceivedFocalLength });
      postMessage({
        type: 'blindspotPerceivedFocalLength',
        content: { perceivedFocalLength: calculatedPerceivedFocalLength },
      });
      setDetectDistance(false);
      setStartFaceRecognition(false);
      collections = [];
    }
  }, [faceApiDetections]);

  useEffect(() => {
    switch (messageFromOptician.type) {
      case 'startPupillaryDistanceDetection':
        console.log('startPupillaryDistanceDetection');
        setDetectDistance(true);
        setStartFaceRecognition(true);
        break;
      case 'stopPupillaryDistanceDetection':
        setDetectDistance(false);
        setStartFaceRecognition(false);
        break;
      default:
        break;
    }
  }, [messageFromOptician]);

  useEffect(() => {
    if (detectDistance === true && startFaceRecognition === true) {
      setReadyToStart(true);
    }
  }, [detectDistance, startFaceRecognition, setReadyToStart]);

  return (
    <>
      <div style={{ zIndex: -1, position: 'fixed' }}>
        <LocalVideo />
      </div>

      <Flex backgroundColor='#fff' width='100vw' height='100vh'>
        <Flex
          position='absolute'
          backgroundColor='black'
          height={`${blindSpotData.blindSpot.circleDimensionsPx}px`}
          width={`${blindSpotData.blindSpot.circleDimensionsPx}px`}
          right={`${blindSpotData.blindSpot.clientX}px`}
          top={`${blindSpotData.blindSpot.clientY}px`}
          borderRadius='50%'
        />
        <Flex
          id='video-container'
          position='absolute'
          width={`${blindSpotThumbnailWidthPx}px`}
          height={`${blindSpotThumbnailHeightPx}px`}
          top={`${blindSpotData.blindSpotVideo.clientY}px`}
          right={`${blindSpotData.blindSpotVideo.clientX}px`}
          borderRadius={`${calibrationConstants.VIDEO_BORDER_RADIUS}px`}
          boxShadow={theme.elevations.elevation2}
        >
          <RemoteVideo />
        </Flex>
      </Flex>
    </>
  );
};

export default BlindspotCameraCalibration;
